import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface PinCode {
    delete_timestamp: string | null;
    code: string;
    entity_type: string;
    entity_id: string;
    challenge: string | null;
    type: PinCodeType;
    rendering: PinCodeRendering | null;
    valid_timestamp: string | null;
    update_timestamp: string;
    id: string;
    account_id: string;
    creation_timestamp: string;
}

export interface CreatePinCode {
    code?: string;
    entity_type?: string | null;
    entity_id?: string | null;
    rendering?: PinCodeRendering | null;
    type?: PinCodeType | null;
}

export interface UpdatePinCode {
    retire_timestamp?: string | null;
    code?: string;
}

export enum PinCodeType {
    DROP_OFF = 'drop_off',
    PICK_UP = 'pick_up',
    MASTER = 'master'
}

export enum PinCodeRendering {
    BARCODE_128 = 'barcode_128',
    QR_CODE = 'qr_code',
    QR_CODE_AND_TEXT = 'qr_code_and_text',
    TEXT = 'text'
}

export enum QueryParams {
    CODE = 'code',
    ACCOUNT_ID = 'account_id',
    ENTITY_ID = 'entity_id',
    ENTITY_TYPE = 'entity_type'
}

export type PinCodeQueryParams = QueryParams & DefaultQueryParams;
export type PinCodeListResponse = PaginatedResponse<PinCode>;
